export var STUBBED_COMPETITION_EXISTING_DATA = {
    existingUploadDirectories: [
        {
            name: "TestDirectory1",
            files: [
                {
                    name: "testfile1.csv",
                    gcsPath: "gs://bucket/folder/testfile1.csv",
                    size: 123
                },
                {
                    name: "testfile2.csv",
                    gcsPath: "gs://bucket/folder/testfile2.csv",
                    size: 312
                }, 
            ],
            directories: [
                {
                    name: "SubDirectory",
                    directories: [],
                    files: [
                        {
                            name: "testfile3.csv",
                            gcsPath: "gs://bucket/folder/testfile3.csv",
                            size: 99912
                        }, 
                    ]
                }, 
            ]
        }, 
    ],
    existingUploadFiles: [
        {
            name: "rootfile1.txt",
            gcsPath: "gs://bucket/folder/rootfile1.txt",
            size: 123
        },
        {
            name: "rootfile2.txt",
            gcsPath: "gs://bucket/folder/rootfile2.txt",
            size: 312
        }, 
    ],
    existingRemoteUrls: []
};
export var STUBBED_DATASETS_EXISTING_DATA = {
    existingUploadDirectories: [
        {
            name: "TestDirectory1",
            files: [
                {
                    name: "testfile1.csv",
                    gcsPath: "gs://bucket/folder/testfile1.csv",
                    size: 123
                },
                {
                    name: "testfile2.csv",
                    gcsPath: "gs://bucket/folder/testfile2.csv",
                    size: 312
                }, 
            ],
            directories: [
                {
                    name: "SubDirectory",
                    directories: [],
                    files: [
                        {
                            name: "testfile3.csv",
                            gcsPath: "gs://bucket/folder/testfile3.csv",
                            size: 99912
                        }, 
                    ]
                }, 
            ]
        }, 
    ],
    existingUploadFiles: [
        {
            name: "rootfile1.txt",
            gcsPath: "gs://bucket/folder/rootfile1.txt",
            size: 123
        },
        {
            name: "rootfile2.txt",
            gcsPath: "gs://bucket/folder/rootfile2.txt",
            size: 312
        }, 
    ],
    existingRemoteUrls: []
};
